<template>
	  <main>
		<p class="history-count">Showing the last 30 records.</p>
		<h5 class="mt-3 mb-3">eBay Category Sync History</h5>
		<div class="history">
		  <div v-for="h in history">
			<div class="row">
				<div class="col-5">
				  <b>Status:</b>  {{h.status}}. <i v-if="h.status == 'running'" class="fas fa-cog fa-spin"></i><br/>
				  <b>Last log:</b>  {{h.status_update.split(',').slice(-1).pop()}}.
				</div>
				<div class="col-5">
				  <b>Started:</b>  {{$moment(h.created_at).calendar(null,{sameElse: 'lll'})}}.<br/>
				  <b v-if="h.status == 'running'">Last update:</b> <b v-else>Finished:</b> {{$moment(h.updated_at).calendar(null,{sameElse: 'lll'})}}.
				</div>
				<div class="col-2 text-center">
					<button class="btn btn-primary" 
					v-on:click.prevent="output = JSON.parse(h.output)">Output</button>
				</div>
		  </div>
	  </div>
	</div>
	<div v-if="output" class="plog">
		<div class="row">
			<div class="col-6">
			<h2>Output</h2> 
			</div>
			<div class="col-6">
			<button v-on:click.prevent="output = ''" class="btn btn-secondary pull-right">Close</button>
			</div>
		</div>
		<div class="row">
			<div class="col-12 py-3">
				<table>
					<tr>
						<th>Added ({{Object.keys(output.added).length}})</th>
						<th>Turned from leaf ({{Object.keys(output.leaf_parent).length}})</th>
						<th>Deleted ({{Object.keys(output.deleted).length}})</th>
					</tr>
					<tr>
						<td>
							<div v-for="added in output.added" v-if="added.items && added.items.length > 0">
								<span class="has-items" @click="added.show = !added.show">{{added.text}}</span>
								<div :class="added.show ? 'show' : ''">
									<div v-for="i in added.items">{{i}}</div>
								</div>
							</div>
							<div v-for="added in output.added" v-if="!added.items">
								<span>{{added.text}}</span>
							</div>
						</td>
						<td>
							<div v-for="leaf_parent in output.leaf_parent" v-if="leaf_parent.items && leaf_parent.items.length > 0">
								<span class="has-items" @click="leaf_parent.show = !leaf_parent.show">{{leaf_parent.text}}, item count {{leaf_parent.items ? leaf_parent.items.length : 0}}</span>
								<div :class="deleted.show ? 'show' : ''">
									<div v-for="i in deleted.items">{{i}}</div>
								</div>
							</div>
							<div v-for="leaf_parent in output.leaf_parent" v-if="!leaf_parent.items">
								<span>{{leaf_parent.text}}</span>
							</div>
						</td>
						<td>
							<div v-for="deleted in output.deleted" v-if="deleted.items && deleted.items.length > 0">
								<span class="has-items" @click="deleted.show = !deleted.show">{{deleted.text}}, item count {{deleted.items ? deleted.items.length : 0}}</span>
								<div :class="deleted.show ? 'show' : ''">
									<div v-for="i in deleted.items">{{i}}</div>
								</div>
							</div>
							<div v-for="deleted in output.deleted" v-if="!deleted.items">
								<span>{{deleted.text}}</span>
							</div>
						</td>
					</tr>
					
				</table>
			</div>
		</div>
	</div>
  </main>
</template>
	
	<script>
	export default {
		name: 'EbayCategories',
		data: function() {
			return {
				history: [],
				plog: [],
				plognoitem: [],
				output: ''
			};
		},
		methods: {
			refresh: function() {
				this.$axios.get(`/script/EbayImportCategories`)
					.then((response) => {
						// console.log(response.data.data);
	
						this.history = response.data.data;
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(()=>{
						//
					});
			}
		},
		mounted: function() {
			this.refresh();
			setInterval(() => {
				this.refresh();
			}, 3000);
		},
	};
	</script>
	
	<style scoped lang="less">
	.history {
	  margin-left: -15px;
	}
	.history > div{
	  border-top: 1px solid #efefef;
	  padding: 15px;
	}
	.history-count{
	  position: absolute;
	  right: 30px;
	  margin: 0;
	}
	.plog{
		.headline{
			background: #efefef;
			padding: 5px;
		}
		
		padding: 30px;
		background:#fff;
		position: fixed;
		top:0;
		left: 0;
		width:100%;
		height: 100%;
		z-index: 20;
		overflow-y: scroll;
		
		.logitem{
			padding: 0;
			margin: 20px 0 0 0;
			border-top:1px solid #efefef;
			border-left: 4px solid #efefef;
			border-right: 4px solid #efefef;

			.meta{
				padding-left: 20px;
				border-bottom: 1px solid #efefef;

			}
		}
	}
	
	table{
		vertical-align: top;
		width:100%;
	}
	table td, table th{
		border-right:1px solid #ccc;
		padding: 10px;
		vertical-align: top;
	}
	
	table td > div{
		border-bottom: 1px solid #ccc;
		
		.has-items{
			font-weight: bold;
			cursor: pointer;
		}
		
		
	}
	
	table td > div > div{
		background: #efefef;
		padding: 10px;
		display: none;
		&.show{
			display: block;
		}
		div{
			border-bottom:1px solid #fff;
		}
	}
	
	
	</style>
	